import React, { Component } from 'react';
import { connect } from "react-redux";
import PasswordModal from "components/PasswordModal/PasswordModal";
import { Well, FormGroup, ControlLabel, Button } from "react-bootstrap";
import NumberFormat from 'react-number-format';
import { formatToDecimal, roundNumber } from "utils/Number/NumberUtils"
import { showWarningMessage, showSuccessfulMessage } from "reducers/application/applicationActions";
import classNames from 'classnames';
import { fetchUnlockRequestInfo, saveUnlockRequest } from 'reducers/unlockrequest/unlockrequestActions';
import Auth from "../../auth/Auth";
class UnlockRequest extends Component {
    user;
    auth;
    constructor(props) {
        super(props);
        this.auth = new Auth();
        this.user = this.auth.getUser();
        this.state = {
            amount: 0,
            amountError: null,
            showPasswordModal: false,
            passwordModalLoading: false,
            signed: this.user.signed
        };
    }

    componentWillMount() {
        this.props.fetchUnlockRequestInfo();
    }

    valid = () => {

        if (!this.state.signed) {
            this.props.showWarningMessage("Ud. no completó la firma del contrato, no puede habilitar saldo pendiente");
            return false;
        }

        if (this.state.amount == null || this.state.amount == undefined || this.state.amount <= 0) {
            this.props.showWarningMessage("Por favor ingrese un monto válido a habilitar");
            this.setState({ amountError: "Ingrese un monto válido a habilitar" });
            return false;
        }

        if (this.state.amount > this.props.unlockRequestInfo.availableBlockedAmount) {
            this.props.showWarningMessage("El monto a habilitar no puede ser mayor al saldo disponible");
            return false;
        }
        return true;
    };

    cleanAmountError() {
        this.setState({ amountError: null });
    };

    showPasswordModal = () => {
        if (this.valid()) {
            this.setState({ showPasswordModal: true })
        }
    };

    requestUnlock(password) {
        this.setState({ passwordModalLoading: true });

        let promise = new Promise((resolve, reject) => {
            let requestDto = {
                amount: this.state.amount,
                password: password
            };
            this.props.saveUnlockRequest(requestDto, resolve, reject);
        });
        promise.then(() => {
            this.props.showSuccessfulMessage("Solicitud de desbloqueo enviada correctamente");
            this.props.fetchUnlockRequestInfo();
            this.setState({
                amount: 0,
                amountError: null,
                showPasswordModal: false,
                passwordModalLoading: false
            });
        }, () => {
            this.setState({
                passwordModalLoading: false,
                showPasswordModal: false,
                amount: 0
            });
        });
    }

    render() {
        const { amountError } = this.state;
        const amountClass = classNames('form-group',
            { 'has-error': amountError != null }
        );
        return (
            <div>
                <div className="d-flex justify-content-center align-items-center">
                    <Well bsSize="large" bsClass="wallet_transfer__card">

                        <div className="wallet-transfer__balance_cont">
                            {this.props.unlockRequestInfo != null &&
                            <div>
                                <div className="wallet-transfer__balance">
                                    <b>Saldo pendiente: </b><span><b>{formatToDecimal(roundNumber(this.props.unlockRequestInfo.availableBlockedAmount))} {this.props.unlockRequestInfo.currency}</b></span>
                                </div>
                            </div>
                            }
                        </div>

                        <div className={amountClass}>
                            <ControlLabel><b>Monto a Habilitar</b></ControlLabel> <br />
                            <NumberFormat
                                className="form-control input-sm form-control-sm wallet-transfer__amount"
                                value={this.state.amount}
                                decimalScale={2}
                                thousandSeparator={true}
                                suffix={'Bs'}
                                onValueChange={(values) => {
                                    const { formattedValue, value } = values;
                                    if (value != null && value != undefined && value > 0) {
                                        this.cleanAmountError();
                                    }
                                    this.setState({ amount: value })
                                }} />
                            <span className="help-block">{amountError}</span>
                        </div>

                        <FormGroup>
                            <Button className="bg-light-secondary float-right" onClick={this.showPasswordModal}>Habilitar</Button>
                        </FormGroup>
                    </Well>
                </div>

                <PasswordModal
                    show={this.state.showPasswordModal}
                    loading={this.state.passwordModalLoading}
                    onHide={() => this.setState({ showPasswordModal: false })}
                    save={(password) => this.requestUnlock(password)}
                    buttonLabel="Confirmar Solicitud de Desbloqueo"
                />

            </div>
        )
    }
}

const mapStateToProps = state => ({
    unlockRequestInfo: state.unlockRequest.data
});

export default connect(mapStateToProps, {
    fetchUnlockRequestInfo,
    saveUnlockRequest,
    showWarningMessage,
    showSuccessfulMessage})
(UnlockRequest);



// WEBPACK FOOTER //
// ./src/components/UnlockRequest/UnlockRequest.jsx